import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M15.819 7.514c-.252-.09-.498-.047-.664-.008-.17.04-.375.108-.599.183L10.07 9.184l-.03.01c-.106.035-.255.084-.386.173a1.1 1.1 0 0 0-.287.287c-.09.13-.138.28-.173.386l-.01.03-1.495 4.486c-.075.224-.143.43-.183.599-.04.166-.081.412.008.664a1.1 1.1 0 0 0 .667.666c.252.09.498.048.664.01.17-.04.375-.11.599-.184l4.486-1.495.03-.01a1.5 1.5 0 0 0 .386-.173 1.1 1.1 0 0 0 .287-.287c.089-.13.138-.28.173-.386l.01-.03 1.495-4.486c.075-.224.143-.43.183-.599.04-.166.081-.412-.009-.664a1.1 1.1 0 0 0-.666-.667Zm-.907 1.321c.16-.053.28-.093.374-.122-.028.094-.068.214-.121.375l-1.488 4.463a9.04 9.04 0 0 1-.029.086l-.003.008-.008.003-.086.03-4.463 1.487c-.16.053-.28.093-.375.122.029-.094.068-.214.122-.375l1.488-4.463c.011-.035.02-.063.029-.086l.002-.008.009-.003a9.04 9.04 0 0 1 .086-.03l4.463-1.487Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm8.8-10a8.8 8.8 0 1 1-17.6 0 8.8 8.8 0 0 1 17.6 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
